import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=2820c77d&scoped=true&"
import script from "./LeftBar.vue?vue&type=script&lang=ts&"
export * from "./LeftBar.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=2820c77d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820c77d",
  null
  
)

export default component.exports